import { render, staticRenderFns } from "./CapsVTextField.vue?vue&type=template&id=f6457ce4"
import script from "./CapsVTextField.vue?vue&type=script&lang=js"
export * from "./CapsVTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports